import {lazy} from 'react';

export const TermTooltipLazy = lazy(() => import(/* webpackChunkName: "termTooltip" */ '.'));
